import Vue from 'vue'
import axios from 'axios'
import i18n from '../../helpers/i18nHelpers'

const vueObj = new Vue()

const state = {
  isApplying: false,
  appliedPromoCode: null,
  promoCodeValue: null,
  promoCodes: null,
  hasPromoCode: null,
  savedPromoCode: null
}

const actions = {
  fetchPromoCodes: async ({commit}, params) => {
    commit('SET_PROMO_CODES', null)
    const url = `/promo-codes`
    const res = await axios.get(url, {params})
    const response = res.data
    if (!response.error) {
      commit('SET_PROMO_CODES', response.promo_codes)
    }
  },
  searchPromoCode: async ({commit}, submitData) => {
    commit('SET_HAS_PROMO_CODE', null)
    const url = 'bookings/apply-promo-code'
    const res = await axios.post(url, submitData)
    const response = res.data
    if (!response.error) {
      commit('SET_HAS_PROMO_CODE', true)
      commit('ADD_PROMO_CODE', response.promo_code)
    } else {
      commit('SET_HAS_PROMO_CODE', false)
    }
  },
  APPLY_PROMO_CODE: ({commit}, submitData) => {
    // console.log('promo code data', submitData)
    commit('SET_APPLYING_PROMO_CODE', true)
    const url = 'bookings/apply-promo-code'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_APPLYING_PROMO_CODE', false)
        if (!response.error) {
          // console.log('applied promo code01', response)
          // Set applied promo code
          let appliedPromoCode = response
          // Check key (is_applied) existing
          appliedPromoCode.is_applied = (response.is_applied !== undefined) ? response.is_applied : true
          commit('SET_APPLIED_PROMO_CODE', appliedPromoCode)
        } else {
          let errorMsg
          switch (response.status) {
            case 'promo_code_used':
              errorMsg = i18n.t('message.alert.promo_code_used')
              break
            case 'promo_code_full':
              errorMsg = i18n.t('message.alert.promo_code_full')
              break
            case 'no_promo_code':
              errorMsg = i18n.t('message.alert.no_promo_code')
              break
            case 'referral_code_used':
              errorMsg = i18n.t('message.alert.referral_code_used')
              break
            case 'cannot_apply_your_own_code':
              errorMsg = i18n.t('message.alert.cannot_apply_your_own_code')
              break
            case 'promo_code_location':
              errorMsg = i18n.t('message.alert.promo_code_location')
              break
            case 'not_matched_conditions':
              errorMsg = i18n.t('message.alert.not_matched_conditions')
              break
            case 'not_matched_payment_method':
              commit('SET_APPLIED_PROMO_CODE', null)
              errorMsg = i18n.t('message.alert.not_matched_conditions')
              break
            default:
              errorMsg = i18n.t('message.alert.no_promo_code')
              break
          }
          vueObj.$swal({text: errorMsg, type: 'error'})
        }
      })
  }
}

const mutations = {
  SET_APPLYING_PROMO_CODE: (state, status) => {
    state.isApplying = status
  },
  SET_APPLIED_PROMO_CODE: (state, appliedPromoCode) => {
    state.appliedPromoCode = appliedPromoCode
  },
  SET_PROMO_CODE_VALUE: (state, code) => {
    state.promoCodeValue = code
  },
  SET_PROMO_CODES: (state, promoCodes) => {
    state.promoCodes = promoCodes
  },
  ADD_PROMO_CODE: (state, searchedPromoCode) => {
    if (state.promoCodes) {
      let isDuplicate = false
      for (const promoCode of state.promoCodes) {
        if (promoCode.id === searchedPromoCode.id) {
          isDuplicate = true
          break
        }
      }
      if (!isDuplicate) {
        state.promoCodes.unshift(searchedPromoCode)
      }
    } else {
      state.promoCodes = []
      state.promoCodes.push(searchedPromoCode)
    }
  },
  SET_HAS_PROMO_CODE: (state, status) => {
    state.hasPromoCode = status
  },
  SET_SAVED_PROMO_CODE: (state, promoCode) => {
    state.savedPromoCode = promoCode
  }
}

const getters = {
  getState: state => {
    return state
  },
  isApplying: state => {
    return state.isApplying ? 'message.button.loading' : 'message.button.apply_code'
  },
  getAppliedPromoCode: state => {
    return state.appliedPromoCode
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/promo.code.js